import React, { Component } from 'react';
import Header from './sections/Header';
import { Container } from 'reactstrap';
import Banner from './sections/Banner';
import Footer from './sections/Footer';
import { removeHyphensAndCapitalize } from '../helpers';
import ErrorBoundary from './sections/ErrorBoundary'
import ItemsList from '../containers/ItemsList';
import Shop from './sections/Shop';
import { withRouter } from 'react-router-dom';
import { string, object } from 'prop-types';
import { COFFEE } from '../utils/constants';
import withCoffeeService from '../hoc/withCoffeeService';
import viewContext from '../contexts/viewContext';

class CoffeePage extends Component {
  static propTypes = {
    url: string,
    coffeeService: object,
  }

  static defaultProps = {
    url: '',
    coffeeService: {},
  }

  state = {
    searchText: ''
  }

  onSearch = (name) => {
    this.setState({ searchText: name })
  }

  onItemSelected = (itemId) => {
    this.props.history.push(itemId)
  }

  render() {
    const { url, coffeeService } = this.props
    const { searchText } = this.state

    return (
      <>
        <Banner pageType={COFFEE} title={removeHyphensAndCapitalize(url)}>
          <Container>
            <Header />
          </Container>
        </Banner>

        <ErrorBoundary>
          <viewContext.Provider value={(<Shop />)}>
            <ItemsList
              items={COFFEE}
              pageType={COFFEE}
              getData={coffeeService.getItems.bind(null, COFFEE)}
              onSearch={this.onSearch}
              searchText={searchText}
              onItemSelected={this.onItemSelected}
            />
          </viewContext.Provider>
        </ErrorBoundary>

        <Footer />
      </>
    )
  }
}

export default withCoffeeService()(withRouter(CoffeePage))
